<div [class.ig-border-spinner]="item.pinnedTime" [class.h-full]="item?.socialName==='promotion'">
  <div class="shadow-md bg-white transition-all cursor-pointer hover:shadow-2xl square-card relative h-full"
    [class.ig-pinned]="item?.pinnedTime" (click)="showDetails()">
    <ig-image [src]="item?.cover?.source" [alt]="item?.name" class="h-full"
      cls="w-full h-full object-cover aspect-[1/1]"></ig-image>

    <ng-container *ngIf="item?.socialName!=='promotion'">
      <ig-event-time *ngIf="getItemType()==='event'" [item]="item"></ig-event-time>
      <div *ngIf="getItemType()==='place'"
        class="leading-8 text-white text-sm text-center flex items-center root-event-btn-bg h-8 justify-center max-lines-1">
        <span *ngIf="!isSearchName">{{item?.title || item?.name}}</span>
        <span *ngIf="isSearchName" [innerHTML]="(item?.title || item?.name)| highlight:keyword"></span>
      </div>

      <div class="h-8 leading-8 text-white text-sm font-semibold text-center root-detail-btn-bg">DETAILS
      </div>

      <div *ngIf="!frontendSettings?.customSettings?.isHideEditorChoice && item?.isChoice"
        class="absolute top-5 right-0 px-2 py-0 bg-red-500 text-white text-sm flex items-center">
        <mat-icon class="text-base">favorite</mat-icon>{{getItemType()==='event' ? editorChoiceText.editorChoiceForEvent
        : editorChoiceText.editorChoiceForPlace}}
      </div>
    </ng-container>
  </div>
</div>